import React, { useState, useEffect, useRef } from 'react';
import { Package, Plane, Ship } from 'lucide-react';

const PROOF_ITEMS = [
  { name: 'Ігор', city: 'Київ', weight: 55.8, delivery_type: 'air' },
  { name: 'Олена', city: 'Львів', weight: 12.4, delivery_type: 'air' },
  { name: 'Андрій', city: 'Дніпро', weight: 230, delivery_type: 'sea' },
  { name: 'Марина', city: 'Одеса', weight: 8.6, delivery_type: 'air' },
  { name: 'Сергій', city: 'Харків', weight: 96.5, delivery_type: 'sea' },
  { name: 'Вікторія', city: 'Київ', weight: 17.1, delivery_type: 'air' },
  { name: 'Дмитро', city: 'Запоріжжя', weight: 41.3, delivery_type: 'air' },
  { name: 'Наталія', city: 'Вінниця', weight: 6.9, delivery_type: 'air' },
  { name: 'Олександр', city: 'Полтава', weight: 148, delivery_type: 'sea' },
  { name: 'Тетяна', city: 'Черкаси', weight: 10.7, delivery_type: 'air' },
  { name: 'Максим', city: 'Івано-Франківськ', weight: 27.5, delivery_type: 'air' },
  { name: 'Юлія', city: 'Рівне', weight: 5.2, delivery_type: 'air' },
  { name: 'Володимир', city: 'Хмельницький', weight: 315, delivery_type: 'sea' },
  { name: 'Анна', city: 'Чернігів', weight: 14.8, delivery_type: 'air' },
  { name: 'Павло', city: 'Луцьк', weight: 62, delivery_type: 'sea' },
  { name: 'Катерина', city: 'Суми', weight: 9.3, delivery_type: 'air' },
  { name: 'Роман', city: 'Тернопіль', weight: 33.6, delivery_type: 'air' },
  { name: 'Світлана', city: 'Житомир', weight: 21.9, delivery_type: 'air' },
  { name: 'Богдан', city: 'Ужгород', weight: 78.4, delivery_type: 'sea' },
  { name: 'Ірина', city: 'Миколаїв', weight: 11.5, delivery_type: 'air' },
];

const shuffle = (arr) => [...arr].sort(() => Math.random() - 0.5);

export const SocialProofPopups = ({ active }) => {
  const [items] = useState(() => shuffle(PROOF_ITEMS));
  const [current, setCurrent] = useState(null);
  const idxRef = useRef(0);

  useEffect(() => {
    if (!active) return;
    let hideTimer;
    let nextTimer;

    const show = () => {
      setCurrent(items[idxRef.current % items.length]);
      idxRef.current += 1;
      hideTimer = setTimeout(() => {
        setCurrent(null);
        nextTimer = setTimeout(show, 4000);
      }, 6000);
    };

    const firstTimer = setTimeout(show, 1500);
    return () => { clearTimeout(firstTimer); clearTimeout(hideTimer); clearTimeout(nextTimer); };
  }, [items, active]);

  if (!current) return null;

  return (
    <div
      className="fixed left-4 bottom-36 md:bottom-20 z-[45] max-w-[300px] animate-slideUpFade"
      data-testid="social-proof-popup"
    >
      <div className="relative overflow-hidden rounded-xl border border-blue-500/30 bg-[#0a1224]/95 backdrop-blur-xl shadow-[0_0_25px_-8px_rgba(59,130,246,0.6)] p-3.5 flex items-center gap-3">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-400/50 to-transparent" />
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 shadow-lg ${current.delivery_type === 'sea' ? 'bg-gradient-to-br from-cyan-500 to-blue-600' : 'bg-gradient-to-br from-blue-500 to-indigo-600'}`}>
          {current.delivery_type === 'sea' ? <Ship className="w-5 h-5 text-white" /> : <Plane className="w-5 h-5 text-white" />}
        </div>
        <div className="min-w-0">
          <p className="text-white text-sm font-medium leading-snug">
            {current.name} з м. {current.city} замовив(ла) доставку <span className="text-cyan-400 font-bold">{current.weight} кг</span>
          </p>
          <p className="text-slate-500 text-[11px] mt-0.5 flex items-center gap-1">
            <Package className="w-3 h-3" /> нещодавно • CargoAgs
          </p>
        </div>
      </div>
    </div>
  );
};
